export default __webpack_public_path__ + "static/05-8c7f34fb8adc04ab66cc2122491f9ea9.jpg";